import React, { useEffect, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'
import { api } from '../../services/api'
import Card from '../../components/Card'
import Spinner from '../../components/Spinner'

export default function () {
	const { token } = useParams()

	const [isTokenValid, setIsTokenValid] = useState(null)

	const { mutate } = useMutation({
		mutationFn: async () => {
			try {
				await api.put('usuario/confirmacao', { token })

				setIsTokenValid(true)
			} catch(e) {
				setIsTokenValid(false)
			}
		}
	})

	useEffect(() => {
		mutate()
	}, [])

	const isPending = isTokenValid === null

	return (
		<div className="sm:mx-36 mt-16 mb-16 2xl:mb-[20vh] animated fadeInUp faster flex flex-col items-center">
			<Card className="flex flex-col gap-8 bg-white text-slate-800 max-w-[400px]">
				{isPending ? (
					<div>
						<Spinner label="Confirmando seu e-mail..." />
					</div>
				) : (
					<>
						{isTokenValid ? (
							<>
								<div className="flex flex-col items-center gap-2">
									<FiCheckCircle size={56} className="text-emerald-400" />
									<h1 className="text-center text-slate-800">Seu e-mail está confirmado!</h1>
								</div>

								<p className="text-center font-medium">
									O próximo passo é acessar sua conta e escolher o plano que melhor se aplica a você.
								</p>
							</>
						) : (
							<>
								<div className="flex flex-col items-center gap-2">
									<FiXCircle size={56} className="text-red-500" />
									<h1 className="text-center text-slate-800">Link não reconhecido!</h1>
								</div>

								<p className="text-center">Verifique o endereço acessado e tente novamente.</p>
							</>
						)}

						<Link to="/login" className="button self-center">
							Ir para o login
						</Link>
					</>
				)}
			</Card>
		</div>
	)
}
